<template>
  <div class="md-layout">

    <!-- Begin: Sidepanel -->
    <div class="_portalRoot">
      <portal to="sidepanel-portal-dependents">
        <!-- Parent Product Option section -->
        <!-- <DynamoList :list.sync="poParentList" :filter="productOptionChildIdFilter" ref="poParentListRef"></DynamoList> -->
        <ElasticList :list.sync="poParentList" :filter="productOptionChildIdFilter" ref="poParentListRef"></ElasticList>

        <md-dialog :md-active.sync="poParentList.showRelatedDialog">	
          <md-dialog-title>{{relatePOParentList.pageTitle}}</md-dialog-title>	

          <md-dialog-content>	
            <ElasticList	
              v-if="recordData"	
              :list.sync="relatePOParentList"	
              :exclude="relateProductOptionListFilter"
              :relateRecordInput="newRecordInputParent"
              :relateRecordInputField="relatePOParentList.relateRecordInputField"
              :relateRecordInputParentId="relatePOParentList.relateRecordInputParentId"
            ></ElasticList>	
          </md-dialog-content>

          <md-dialog-actions>	
            <md-button class="md-theme-default" @click="poParentList.showRelatedDialog = false; poParentList.needsRefresh = true;">Close</md-button>	
          </md-dialog-actions>	
        </md-dialog>

        <!-- Dependencies/Child Product Option section -->
        <!-- <DynamoList :list.sync="poChildList" ref="poChildListRef"></DynamoList> -->
        <ElasticList :list.sync="poChildList" :filter="productOptionParentIdFilter" ref="poChildListRef"></ElasticList>

        <md-dialog :md-active.sync="poChildList.showRelatedDialog">	
          <md-dialog-title>{{relatePOChildList.pageTitle}}</md-dialog-title>	
          	
          <md-dialog-content>	
            <ElasticList	
              v-if="recordData"	
              :list.sync="relatePOChildList"	
              :exclude="relateProductOptionChildListFilter"
              :relateRecordInput="newRecordInputChild"
              :relateRecordInputField="relatePOChildList.relateRecordInputField"
              :relateRecordInputParentId="relatePOChildList.relateRecordInputParentId"
            ></ElasticList>	
          </md-dialog-content>

          <md-dialog-actions>	
            <md-button class="md-theme-default" @click="poChildList.showRelatedDialog = false; poChildList.needsRefresh = true;">Close</md-button>	
          </md-dialog-actions>	
        </md-dialog>
      </portal>
    </div>
    <!-- End: Sidepanel -->

    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">

        <md-tab id="tab-account" md-label="Product" :to="recordPath" exact>
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
    </div>

  </div>
</template>

<script>
  import Record from '@/mixins/Record';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import Amplify, { Auth, API, graphqlOperation, JS } from "aws-amplify";
  import * as queries_custom from "@/graphql/queries_custom"; 

  export default {
    name: "productoption",
    mixins: [Record],
    data() {
      return {
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'productOptionUpdatedById',
          removeFields: ['children'],
          responseFieldName: 'getProductOption',
          actions: {
            save: 'createProductOption',
            view: 'getProductOption',
            edit: 'editProductOption',
            new: 'newProductOption',
            update: 'updateProductOption',
            delete: 'deleteProductOption',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
          },
          listPath: "/productoptions",
          headerIcon: 'devices',
          objectName: 'ProductOption',
          objectNamePlural: 'Product Options',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            name: { label: "Name", type: "text", slot: 'basic' },
            category: { label: "Category", type: "select", slot: 'basic', options: [], optionType: 'enum' },
            brand: { label: "Brand", type: "select", slot: 'basic', options: [], optionType: 'enum' },
            legacyName: { label: "Legacy Name", type: "text", slot: 'basic' },
            status: { label: "Status", type: "switch", slot: 'basic', value: true },
            notes: { label: "Notes", type: "textEditor", slot: 'basic' },
            // children: {
            //   label: "Dependencies", type: "parentchild", slot: 'basic',
            //   subscribe: {
            //     'onCreate': {
            //       'model': 'ProductOptionChild',
            //       'inputField': 'children',
            //       'target': 'child'
            //     },
            //     'onDelete': {
            //       'model': 'ProductOptionChild',
            //       'inputField': 'children',
            //       'target': 'child'
            //     }
            //   },
            //   list: {
            //     hideNewRecordButton: true,
            //     hideListHeader: true,
            //     editPath: "productoptions",
            //     recordDataKeyName: "children",
            //     objectName: "child",
            //     pageTitle: "Product Options",
            //     pageIcon: "store",
            //     listQueryId: "searchProductOptions",
            //     createMutationId: "createProductOptionChild",
            //     deleteQueryId: "deleteProductOptionChild",
            //     deleteQueryIdField: "relateRecordId",
            //     deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product Option?",
            //     deleteMessageText: "",
            //     linkRows: false,
            //     itemActions: [
            //       {
            //         class: "md-just-icon md-simple md-warning",
            //         classAdded: "item.added? 'check_circle' : 'md-warning'",
            //         icon: "post_add",
            //         iconAdded: "check_circle",
            //         click: "handleAddPOChild"
            //       }
            //     ],
            //     columns: {
            //       name: { label: "Name", sortable: true },
            //       createdAt: { label: "Created", sortable: true},
            //     },
            //     perPageOptions: [5, 10, 20, 25, 50],
            //     defaults: {
            //       sort: 'createdAt',
            //       sortDir: 'desc',
            //       perPage: 10,
            //     },
            //     fuseSearch: null,
            //     relateRecordInput: {productOptionChildChildId: null, parentId: null},
            //     relateRecordInputField: "productOptionChildChildId",
            //     relateRecordRouteField: "parentId",
            //   },
            // },
          },
          editTitleField: 'name',
          productOptionChildFilter:  'productOptionChildChildId',
          productOptionParentFilter:  'parentId',
        },
        updateFormData: {},
        form: {
          id: "",
          name: "",
          category: "",
          brand: "",
          legacyName: "",    
          status: true,
          notes: "",
          children: []
        },
        categoryOptions: [],
        brandOptions: [],
        parentProductOptionsList: [],
        getPOChildItems: [],
        poParentList: {
          showRelatedDialog: false,
          hideListHeader: false,
          linkRows: true,
          editPath: "productoptions",
          pageTitle: "Parents",
          listQueryId: "searchProductOptionChildCustoms",
          responseFieldName: "searchProductOptionChilds",
          deleteQueryId: "deleteProductOptionChild",
          deleteQueryIdField: "productOptionChildId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product Option?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            'esData.parent.category': { label: "Type", sortable: false, esNested: true},
            'esData.parent.name': { label: "Product Option", sortable: false, esNested: true},
          },
          perPageOptions: [5, 10, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          skipPOParents: [],
          addRelatedParentPO: [],
          formatResponse: (data) => {
            let result = [];
            let parentPOArr = [];
            //this.parentProductOptionsList = []; //reset
            
            if (data && data.searchProductOptionChilds && data.searchProductOptionChilds.items && data.searchProductOptionChilds.items.length) {
              data.searchProductOptionChilds.items.forEach((item) => {
                item.productOptionChildId = item.id;
                item.name = item.parent.name;
                result.push(item);
                this.poParentList.skipPOParents.push(item.parent.id);
              });
            }
            // if (data && data.searchProductOptions && data.searchProductOptions.items && data.searchProductOptions.items.length) {
            //   data.searchProductOptions.items.forEach((item) => {
            //     if(item.id != this.$route.params.id) {
            //       //check if item is parent of current PO
            //       if(item.children && item.children.items && item.children.items.length) {
            //         let childItems = item.children.items;
                    
            //         childItems.forEach((el) => {
            //           if (el.child.id == this.$route.params.id) {
            //             item.productOptionChildId = el.id;
            //             result.push(item);
            //             this.poParentList.skipPOParents.push(item.id);
            //           }
            //         });
            //       }
            //     }
            //   })
            // }
            return result;
          }
        },
        relatePOParentList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "productoptions",
          pageTitle: "Search for Product Options",
          pageIcon: "store",
          listQueryId: "searchProductOptions",
          responseFieldName: "searchProductOptions",
          createMutationId: "createProductOptionChild",
          relateRecordInput: {productOptionChildChildId: null, parentId: null, productOptionChildParentId: null},
          relateRecordInputField: "parentId",
          relateRecordRouteField: "productOptionChildChildId",
          relateRecordInputParentId: "productOptionChildParentId",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddParentPO"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchProductOptions && data.searchProductOptions.items && data.searchProductOptions.items.length) {
              data.searchProductOptions.items.forEach((item) => {
                  item.parentPOName = this.recordData ? this.recordData.name : '';
                  result.push(item);
              });
            }
            return result;
          },
        },
        poChildList: {
          showRelatedDialog: false,
          hideListHeader: false,
          linkRows: true,
          editPath: "productoptions",
          pageTitle: "Dependencies",
          listQueryId: "searchProductOptionChildCustoms",
          responseFieldName: "searchProductOptionChilds",
          deleteQueryId: "deleteProductOptionChild",
          deleteQueryIdField: "productOptionChildId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Product Option?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            'esData.child.category': { label: "Type", sortable: false, esNested: true},
            'esData.child.name': { label: "Product Option", sortable: false, esNested: true},
            required: { label: "Required", sortable: false }
          },
          perPageOptions: [5, 10, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          skipPOChilds: [],
          addRelatedChildPO: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchProductOptionChilds && data.searchProductOptionChilds.items && data.searchProductOptionChilds.items.length) {
              data.searchProductOptionChilds.items.forEach((item) => {
                item.productOptionChildId = item.id;
                item.name = item.child.name;
                result.push(item);
                this.poChildList.skipPOChilds.push(item.child.id);
              });
            }
            return result;
          }
        },
        relatePOChildList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "productoptions",
          pageTitle: "Search for Product Options",
          pageIcon: "store",
          listQueryId: "searchProductOptions",
          responseFieldName: "searchProductOptions",
          createMutationId: "createProductOptionChild",
          relateRecordInput: {productOptionChildChildId: null, parentId: null, productOptionChildParentId: null},
          relateRecordInputField: "productOptionChildChildId",
          relateRecordRouteField: "parentId",
          relateRecordInputParentId: "productOptionChildParentId",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddPOChild"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchProductOptions && data.searchProductOptions.items && data.searchProductOptions.items.length) {
              data.searchProductOptions.items.forEach((item) => {
                  //exclude already added PO dependencies in Add dialog
                  result.push(item);
              });
            }
            return result;
          },
        },
        subscriptions: {
          'onCreateProductOptionChild': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateProductOptionChild');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onCreateProductOptionChild;

              if (this.$route.params.id === eventRecord.parentId) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreateProductOptionChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.poChildListRef.refresh();
                }, 1000);
              } else if (this.$route.params.id === eventRecord.child.id) {
                this.$c.log('SUBSCRIPTION MATCH!:--------------------------------------- onCreateProductOptionChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.poParentListRef.refresh();
                }, 1000);
              }
              //Force a refresh on the ConfigForm component
              this.formConfig.refreshRecordData = true;
            }
          },
          'onDeleteProductOptionChild': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteProductOptionChild');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onDeleteProductOptionChild;

              if (this.$route.params.id === eventRecord.parentId) {
                this.$c.log('SUBSCRIPTION MATCH!: onDeleteProductOptionChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.poChildListRef.refresh();
                }, 500);
              } else if (this.$route.params.id === eventRecord.child.id) {
                this.$c.log('SUBSCRIPTION MATCH!:--------------------------------------- onDeleteProductOptionChild');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.poParentListRef.refresh();
                }, 500);
              }
              //Force a refresh on the ConfigForm component
              this.formConfig.refreshRecordData = true;
            }
          }
        }
      }
    },
    validations() {
      return {
        form: {
          id: {},
          name: {required, minLength: minLength(3)},
          category: {required},
          brand: {},
          legacyName: {},
          status: {},
          notes: {},
          children: {}
        }
      }
    },
    computed: {
      newRecordInputParent: function () {
        let input = this.relatePOParentList.relateRecordInput;
        let routeField = this.relatePOParentList.relateRecordRouteField;
        input[routeField] = this.$route.params.id;
        return input;
      },
      newRecordInputChild: function () {
        let input = this.relatePOChildList.relateRecordInput;
        let routeField = this.relatePOChildList.relateRecordRouteField;
        input[routeField] = this.$route.params.id;
        return input;
      },
      //filter poParentList
      productOptionChildIdFilter: function() { 
	      const id = this.$route.params.id ? this.$route.params.id: -1;
        let mustIds = [];
        let mustNotIds = [];
        let filter = {};

        //Match ID
        mustIds.push({ match_phrase: { productOptionChildChildId: id } });
        //exclude IDs
        this.poParentList.skipPOParents.forEach(_id => {
          mustNotIds.push({ match_phrase: { id: _id } });
        });
        //if match IDs exist
        if (mustIds.length) {
          filter.must = [
            { bool: { should: mustIds } }
          ];
        }
        //if exclude IDs exist
        if (mustNotIds.length) {
          filter.must_not = [
            { bool: { should: mustNotIds } }
          ]
        }

        if (Object.keys(filter).length === 0) {
          return;
        }

        return {
          bool: filter
        }
      },
      productOptionParentIdFilter: function() {
        const id = this.$route.params.id ? this.$route.params.id: -1;
        const mustIds = [];
        const mustNotIds = [];
        const filter = {};

        //Match ID
        mustIds.push({ match_phrase: { parentId: id } });
        //exclude IDs
        this.poChildList.skipPOChilds.forEach(_id => {
          mustNotIds.push({ match_phrase: { id: _id } });
        });
        //if match IDs exist
        if (mustIds.length) {
          filter.must = [
            { bool: { should: mustIds } }
          ];
        }
        //if exclude IDs exist
        if (mustNotIds.length) {
          filter.must_not = [
            { bool: { should: mustNotIds } }
          ]
        }

        if (Object.keys(filter).length === 0) {
          return;
        }

        return {
          bool: filter
        }
      },

      relateProductOptionListFilter: function () {
        let result = null;
        let filters = [{"match": {"id": this.$route.params.id}}];
        if (this.updateFormData && this.updateFormData.searchProductOptionChilds && this.updateFormData.searchProductOptionChilds.items && this.updateFormData.searchProductOptionChilds.items.length) {
          this.updateFormData.searchProductOptionChilds.items.forEach((item) => {
            if(item.child.id === this.$route.params.id){
              filters.push({"match": {"id": item.parent.id}});
            }            
          })
        }
        if (filters.length) {
          result = {"must_not": filters};
        }
        return result;
      },
      relateProductOptionChildListFilter: function () {
        let result = null;
        let filters = [{"match": {"id": this.$route.params.id}}];
        if (this.updateFormData && this.updateFormData.searchProductOptionChilds && this.updateFormData.searchProductOptionChilds.items && this.updateFormData.searchProductOptionChilds.items.length) {
          this.updateFormData.searchProductOptionChilds.items.forEach((item) => {
            if(item.parent.id === this.$route.params.id){
              filters.push({"match": {"id": item.child.id}});
            }            
          })
        }
        if (filters.length) {
          result = {"must_not": filters};
        }
        return result;
      },
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;
        this.updateFormData = data;
        //ATLAS-1244: get PO dependencies from getProductOption query
        if (data.getProductOption && data.getProductOption.children && data.getProductOption.children.items) {
          this.getPOChildItems = data.getProductOption.children.items;
        }

        this.getCategoryEnumOptions(data);
        this.getBrandEnumOptions(data);
        this.loadRelatedRecords(data, 'children', 'child');
      },
      loadRelatedRecords(data, name, target) {
        let result = [];
        if (data && data.getProductOption && data.getProductOption[name] && data.getProductOption[name].items && data.getProductOption[name].items.length) {
          let items = data.getProductOption[name].items;
          items.forEach(item => {
            if(item[target]){
              item[target].relateRecordId = item.id;
              result.push(item[target]);
            }

          });
        }
        this.form[name] = result;
      },

      getCategoryEnumOptions(data) {
        this.categoryOptions = [];
        if (data.listProductCategoryEnum && data.listProductCategoryEnum.enumValues) {
          data.listProductCategoryEnum.enumValues.map(_value => {
            this.categoryOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          console.log('this.categoryOptions ',this.categoryOptions)
          this.formConfig.fields.category.options = this.categoryOptions;
        }
      },
      getBrandEnumOptions(data) {
        this.brandOptions = [];
        if (data.listProductBrandEnum && data.listProductBrandEnum.enumValues) {
          data.listProductBrandEnum.enumValues.map(_value => {
            this.brandOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          console.log('this.brandOptions ',this.brandOptions)
          this.formConfig.fields.brand.options = this.brandOptions;
        }
      },
      getDependenciesCount() {
        //using refs due to elastic list component
          let poParentLength = 0;
          let poChildLength = 0;
          if (this.$refs && this.$refs.poParentListRef && this.$refs.poParentListRef.activeData && this.$refs.poParentListRef.activeData.items) {
            poParentLength = this.$refs.poParentListRef.activeData.items.length;
          }
          if (this.$refs && this.$refs.poChildListRef && this.$refs.poChildListRef.activeData && this.$refs.poChildListRef.activeData.items) {
            poChildLength = this.$refs.poChildListRef.activeData.items.length;
          }
          let totalCount = poParentLength + poChildLength;
          window.$bus.$emit("badge-changed", 'dependents', totalCount);
      }

    },
    watch: {
      /**
       * ATLAS-1012: <Product Option> <Side Panel> Product Dependencies
       * Refresh the PO List on route change
       */
      '$route.params.id': function () {
        window.setTimeout(() => {
          this.$refs.poParentListRef.refresh();
          this.$refs.poChildListRef.refresh();
        }, 300);
      },
      "poChildList.skipPOChilds": {
        immediate: true,
        handler: function() {
          this.getDependenciesCount();
        }
      },
      "poParentList.skipPOParents": {
        immediate: true,
        handler: function() {
          this.getDependenciesCount();
        }
      }
    }
  }
</script>

<style>
/* for Dependencies Tab */
#dependents h4.title {
  font-weight: 600 !important;
  font-size: 15px;
}
#dependents .md-card.md-theme-default {
  box-shadow: none;
}
#dependents .md-field._uiKitInput.md-theme-default.md-has-placeholder {
  max-width: 33%;
}
#dependents .md-field._uiKitInput.md-theme-default.md-has-value {
  max-width: 33%;
}
#dependents .md-button {
  min-width: 13%;
  font-size: 10px;
}
#dependents .md-table-cell-container {
  font-size: 0.80rem;
}
#dependents .md-table-head-label {
  font-size: 0.82rem;
}
#dependents p.card-category.number {
  font-size: 0.82rem;
}
#dependents .md-card-actions.md-alignment-space-between {
  margin-left: 16px !important;
  margin-top: 0;
}
</style>

<!-- <style lang="scss"> 

//   .md-tabs .md-tabs-navigation {
//     padding-left: 15px;
//     color: black;
//     display: none;

//     .md-tab-nav-button.md-button {
//       color: black !important;

//       &.active {
//         color: black !important;
//         border-bottom: 2px solid black;
//       }
//     }
//   }

//   .md-content .md-tabs-container .md-tab > .md-layout-item {
//     padding-left: 0;
//     padding-right: 0;
//   }

// </style>
